import React from 'react';
import './App.css';
import Bible from './Bible/Bible';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-select/dist/css/bootstrap-select.min.css';
import 'bootstrap-select';

function App() {
  return (
    <div className="App">
      <Bible />
    </div>
  );
}

export default App;